import { System } from '../../../shared-components/System';

export class ReportqueueFilter {
    // Properties
	private _startDate: Date = undefined;
	private _endDate: Date = undefined;
	SISCode = '';
    Term = '';
    ReportName = '';
    RunDate: Date = undefined;
    ReportStatus = '';
    UserName = '';
	Submitted: boolean = false;
	Running: boolean = false;
	Completed: boolean = false;
	ErrorStatus: boolean = false;

	// Methods
	get startDate(): Date {
		return this._startDate;
	}

	set startDate(value: Date) {
		System.roundDateDown(value);
		this._startDate = value;
	}

	get endDate(): Date {
		return this._endDate;
	}

	set endDate(value: Date) {
		System.roundDateUp(value);
		this._endDate = value;
	}
}
